module.exports = __webpack_public_path__ + "img/theroom_amp_thumb.b53aafd1.jpg";